module.exports = __webpack_public_path__ + "static/media/ansible.a886c03f.png";